import { render, staticRenderFns } from "./QuestionReorderingPopup.vue?vue&type=template&id=d00c36aa"
import script from "./QuestionReorderingPopup.vue?vue&type=script&lang=ts"
export * from "./QuestionReorderingPopup.vue?vue&type=script&lang=ts"
import style0 from "./QuestionReorderingPopup.vue?vue&type=style&index=0&id=d00c36aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports